export default "__VITE_ASSET__3oVfp7FW__"